<template >
    <div>        
            
            <div align="center">
                <img src="@/assets/images/logo_dgcp.png" class="img-fluid" alt="Responsive image">
            </div>
            <p class="lead" align="center"><b>S I I D C A P</b></p>
            
            <input type="text" class="form-control m-b-15" name="username" placeholder="Usuario" autocomplete="off" v-model="user.username">

            <input type="password" class="form-control m-b-15" name="password" placeholder="Contraseña" autocomplete="off" v-model="user.password">

            <hr>
            <div align="center">
                <button class="btn btn-outline-success m-b-15" @click="login">Ingresar</button>
            </div>
            
            <modal-loading :id-modal="modalAuth" :title="modalTitle" ></modal-loading>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
const qs= require('qs');
import modalLoading from '../modal/modalLoading';

export default {
    name: 'login',
    data(){
        return {
            user:{
                username:null,
                password:null
            },
            error:false,
            msg:null,
            modalAuth:'autenticate',
            modalTitle:'Autenticando',
            header:[],
            config:[]
        }
    },
    mounted(){
        this.header=Vue.urlP.setHeaders(Vue.auth.getToken());
        this.config=axios.create(this.header);
    },
    methods:{
        login(){
      
            let userA={
                username:this.user.username,
                password:this.user.password
            };
            this.mViewLoad();
            axios.post('login', qs.stringify(userA))
                .then(res => {
                    console.log(res);
                    this.response(res)
                })
                .catch(error =>{
                    console.log(error)
                    setTimeout(()=>{
                        this.mHideLoad();
                    }, 3000)
                    toastr.error('Ha ocurrido un error al iniciar session', 'Error')
                })
            
            },
        response(res){
                this.error=res.data[0].error
                setTimeout(()=>{
                    this.mHideLoad();
                    if(!this.error){
                        toastr.success(''+res.data[0].msg+'', 'Correcto')
                        this.$auth.setToken(res.data[0].user[0].api_token, Date.now()+14400000, res.data[0].user[0].category,res.data[0].user[0].role, res.data[0].user[0].aut_dispose_import);
                        this.$router.push('/dashboard');
                    }else{
                        toastr.error(''+res.data[0].msg+'', 'Error')
                    }
                },2000);
                
                
        },
        mViewLoad(){
            $('#'+this.modalAuth).modal('show');
        },
        mHideLoad(){
            $('#'+this.modalAuth).modal('hide');
        }
    },
    components:{
        'modal-loading':modalLoading
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue